// ==============================
// File: Header.js
// ==============================
export default function Header() {
  const header = document.querySelector('.main-header')
  const btnToggle = document.querySelector('.js-btn-hamburger')
  const drawerWrap = document.querySelector('.header-drawer')
  const drawerNav = document.querySelector('.drawer-nav')

  if (!header || !btnToggle || !drawerWrap || !drawerNav) return

  // ---- Proteção contra init duplicado
  if (header.dataset.headerBound === 'true') return
  header.dataset.headerBound = 'true'

  // Corrige ARIA inicial
  btnToggle.setAttribute('aria-expanded', 'false')
  if (!drawerNav.id) drawerNav.id = 'drawer-nav'
  btnToggle.setAttribute('aria-controls', drawerNav.id)
  drawerNav.setAttribute('aria-hidden', 'true')

  // ---- Scroll: esconder/mostrar
  const threshold = 10
  let lastScroll = 0
  let ticking = false
  let hasScrolledOnce = false

  let headerH = header.offsetHeight
  const handleResize = () => {
    headerH = header.offsetHeight
  }
  window.addEventListener('resize', handleResize, { passive: true })

  const applyHeaderState = currentScroll => {
    if (currentScroll <= 0) {
      header.classList.remove('is-hidden')
      header.classList.add('at-top')
      header.classList.remove('has-scrolled')
      hasScrolledOnce = false
      lastScroll = 0
      return
    }

    header.classList.remove('at-top')

    if (Math.abs(currentScroll - lastScroll) > threshold) {
      if (currentScroll > lastScroll && currentScroll > headerH) {
        header.classList.add('is-hidden')

        if (!hasScrolledOnce) {
          hasScrolledOnce = true
          header.classList.add('has-scrolled')
        }
      } else {
        header.classList.remove('is-hidden')
      }
      lastScroll = currentScroll
    }
  }

  const handleScroll = () => {
    if (!ticking) {
      ticking = true
      requestAnimationFrame(() => {
        applyHeaderState(window.scrollY)
        ticking = false
      })
    }
  }

  // ---- Menu hamburger
  const isOpen = () => drawerNav.classList.contains('is-open')

  const openMenu = () => {
    drawerNav.classList.add('is-open')
    btnToggle.setAttribute('aria-expanded', 'true')
    drawerNav.setAttribute('aria-hidden', 'false')
    document.documentElement.classList.add('is-menu-open')
  }

  const closeMenu = () => {
    drawerNav.classList.remove('is-open')
    btnToggle.setAttribute('aria-expanded', 'false')
    drawerNav.setAttribute('aria-hidden', 'true')
    document.documentElement.classList.remove('is-menu-open')
  }

  const toggleMenu = () => (isOpen() ? closeMenu() : openMenu())

  btnToggle.addEventListener('click', e => {
    e.preventDefault()
    toggleMenu()
  })

  // Fecha ao clicar em qualquer link do drawer
  drawerNav.addEventListener('click', e => {
    const link = e.target.closest('a[href]')
    if (link) closeMenu()
  })

  // Fechar no ESC
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen()) {
      closeMenu()
    }
  })

  // ---- Estado inicial
  window.addEventListener('scroll', handleScroll, { passive: true })
  applyHeaderState(window.scrollY)
}
